import { render, staticRenderFns } from "./UserCreation.vue?vue&type=template&id=2f4f0e0e"
import script from "./UserCreation.vue?vue&type=script&lang=ts"
export * from "./UserCreation.vue?vue&type=script&lang=ts"
import style0 from "./UserCreation.vue?vue&type=style&index=0&id=2f4f0e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports